import React, { useContext, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { LanguageContext } from "../context/language/LanguageContext";
import { modeActions } from "../store/modeSlice";
import { lupaNativePageMap } from "../Utilities/mapUtil";
import "../styles/actionButtons.css";

const CustomButton = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const languageContext = useContext(LanguageContext);
  const isSubmittingRef = useRef(false);
  const buttonStyle = {
    background: props.background,
    color: props.color,
  };

  const handleClick = async () => {
    if (isSubmittingRef.current) return;
    isSubmittingRef.current = true;
    const startPath = window.location.pathname;
    try {
      // logic before continue
      if (props.beforeContinue) {
        await props.beforeContinue();
      }

      // beforeContinue finished late and we've already navigated away — bail out.
      if (window.location.pathname !== startPath) {
        return;
      }

      if (props.nextPage) {
        lupaNativePageChange(props.nextPage);
        dispatch(modeActions.setValueGA4({ value: props.nextPage }));
        if (props.redirect) {
          const parentUrl = sessionStorage.getItem('PARENT_URL');
          if (parentUrl) {
            try {
              const parentOrigin = new URL(parentUrl).origin;
              window.parent.postMessage({
                type: 'NAVIGATE',
                url: parentOrigin
              }, parentOrigin);
            } catch (e) {
              console.error('Failed to post navigation message:', e);
            }
          } else {
            window.location = props.nextPage;
          }
        } else {
          history.push({
            pathname: `${props.nextPage}`,
            search: location.search,
          });
        }
      }
    } finally {
      isSubmittingRef.current = false;
    }
  };

  const lupaNativePageChange = (nextPage) => {
    const pageName = lupaNativePageMap.get(nextPage);

    if (pageName) {
      if (typeof window.LupaNative !== "undefined") {
        try {
          window.LupaNative.pageChange(pageName);
        } catch (e) {
          window.LupaNative.exit();
        }
      }
    }
  };

  return (
    <button
      type="button"
      className={`inline-flex cursor-pointer items-center justify-center border-0 disabled:cursor-not-allowed ${props.className || ""}`}
      onClick={handleClick}
      style={buttonStyle}
      disabled={props.isDisable || props.disabled}
      data-testid={props["data-testid"]}
    >
      {languageContext.getTranslation(props.btnText)}
    </button>
  );
};
export default CustomButton;
